import { jsx } from "react/jsx-runtime";
import { createContext, useState, useEffect, useMemo, useContext } from "react";
import { useFormikContext } from "formik";
const Context = createContext(0);
const SubmitCountProvider = ({
  children,
  initialValue
}) => {
  const [count, setCount] = useState(initialValue || 0);
  const { submitCount } = useFormikContext();
  useEffect(() => {
    setCount((prev) => Math.max(submitCount, prev));
  }, [submitCount]);
  const value = useMemo(() => {
    return count;
  }, [count]);
  return /* @__PURE__ */ jsx(Context.Provider, { value, children });
};
const useSubmitCount = () => {
  const context = useContext(Context);
  return context;
};
export {
  SubmitCountProvider,
  useSubmitCount
};
